import { supabase } from "./supabase";
import type { ImmobilisationTypeMapping } from "../types/immobilisations";

export async function fetchImmobilisationTypesMapping(): Promise<ImmobilisationTypeMapping[]> {
  const { data, error } = await supabase
    .from("immobilisations_types_mapping")
    .select("id, code, libelle, categorie, compte_immo, compte_amort, duree_amort_defaut_mois, amortissable")
    .order("categorie", { ascending: true })
    .order("libelle", { ascending: true });
  if (error) throw error;
  return (data ?? []) as ImmobilisationTypeMapping[];
}

/** Métadonnées facture d'achat utiles à la création d'immobilisation (JSON `factures_achat.metadata`). */
export type FactureAchatImmoMetadata = {
  is_immobilisation?: boolean;
  immo_type_code?: string;
  immo_libelle?: string;
  immo_date_mise_service?: string;
  immo_duree_mois?: number;
};

export async function creerImmobilisationDepuisFacture(params: {
  factureAchatId: string;
  typeImmo: string;
  libelle: string;
  dateMiseService: string | null;
  dureeMois: number | null;
}): Promise<string | null> {
  const dateSql =
    params.dateMiseService && String(params.dateMiseService).trim()
      ? String(params.dateMiseService).split("T")[0]
      : null;
  const { data, error } = await supabase.rpc("creer_immobilisation_depuis_facture", {
    p_facture_achat_id: params.factureAchatId,
    p_type_immo: params.typeImmo,
    p_libelle: params.libelle,
    p_date_mise_service: dateSql,
    p_duree_mois: params.dureeMois,
  });
  if (error) throw error;
  return data as string | null;
}

/** Idempotent : crée la fiche immo liée à la facture si case immobilisation + type renseignés. */
export async function ensureImmobilisationDepuisFactureIfNeeded(
  factureAchatId: string,
  metadata: FactureAchatImmoMetadata | null | undefined
): Promise<void> {
  if (!metadata?.is_immobilisation) return;
  const code = String(metadata.immo_type_code ?? "").trim();
  if (!code) return;
  const dateRaw = metadata.immo_date_mise_service;
  const dateMiseService =
    dateRaw && String(dateRaw).trim() ? String(dateRaw).split("T")[0] : null;
  const duree = metadata.immo_duree_mois;
  await creerImmobilisationDepuisFacture({
    factureAchatId,
    typeImmo: code,
    libelle: String(metadata.immo_libelle ?? "").trim(),
    dateMiseService,
    dureeMois: duree != null && Number.isFinite(Number(duree)) ? Number(duree) : null,
  });
}
